import { render, staticRenderFns } from "./AdminBrandSkus.vue?vue&type=template&id=86051354&scoped=true&"
import script from "./AdminBrandSkus.vue?vue&type=script&lang=ts&"
export * from "./AdminBrandSkus.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBrandSkus.vue?vue&type=style&index=0&id=86051354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86051354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
